<template>
  <m-card
    :class="{ 'cursor-pointer': readOnly }"
    sr-label="View Drug/Device Administration"
    @click="medicationAdministrationOverview()"
  >
    <div
      :class="[
        {
          clickable: !readOnly,
          'marked-incorrect': entry.data.isMarkedIncorrect,
        },
      ]"
    >
      <m-layout-stack horizontal>
        <div class="flex-auto">
          <span><b>Medication administration: </b></span>
          <span v-if="getProductAndQuantityAndRouteAndSite()">{{
            getProductAndQuantityAndRouteAndSite()
          }}</span>
          <span v-if="entry.data.administeringOrganisation">
            • {{ entry.data.administeringOrganisation }}
          </span>
        </div>
        <i v-if="entry.data.isRetrospectivelyAmended" style="white-space: nowrap">{{
          formatRetrospectivelyAmendedLabel
        }}</i>
      </m-layout-stack>
      <div
        v-if="
          entry.data.hiddenFromPatientFacingServices ||
          entry.data.confidentialFromThirdParties ||
          entry.data.linkedProblems.length
        "
      >
        <span class="secondary-text">
          {{ getConfidentialityTextAndLinkedProblems() }}
        </span>
      </div>
      <m-separator v-if="entry.data.additionalInformation" class="m-my-xs" />
      <span v-if="entry.data.additionalInformation">
        {{ entry.data.additionalInformation }}
      </span>
    </div>
  </m-card>
</template>

<script setup lang="ts">
import { openSlideover } from "../../../../composables/dialog/drawer";
import { PatientJournalRecord } from "../types";
import MSeparator from "../../MSeparator";
import { computed } from "vue";
const props = defineProps<{
  entry: PatientJournalRecord;
  readOnly: boolean;
  clickable?: boolean;
}>();

function medicationAdministrationOverview() {
  return props.readOnly
    ? openSlideover(`/clinical/medication-administration/overview/${props.entry.id}`, {
        close: true,
      })
    : undefined;
}

function getProductAndQuantityAndRouteAndSite() {
  const textAsArray = [
    props.entry.data.productName,
    props.entry.data.quantityAdministered,
    props.entry.data.route,
    props.entry.data.site,
  ];

  const text = textAsArray.filter((x) => x).join(" • ");

  return text === "" ? false : text;
}

function getConfidentialityTextAndLinkedProblems() {
  const textArray = [];

  if (props.entry.data.hiddenFromPatientFacingServices) {
    textArray.push("Redacted from Patient Online Access");
  }
  if (props.entry.data.confidentialFromThirdParties) {
    textArray.push("Confidential from Third Parties");
  }

  const text = textArray.join(" • ");

  const problemsArray = props.entry.data.linkedProblems || [];
  const problemDescriptions = problemsArray
    .filter((x) => x.problemCodeDescription)
    .map((x) => x.problemCodeDescription);

  const problemText = problemDescriptions.length
    ? `Linked Problems: ${problemDescriptions.join(", ")}`
    : "";

  const finalTextArray = [text, problemText].filter(Boolean);

  return finalTextArray.length ? finalTextArray.join(" • ") : false;
}

const formatRetrospectivelyAmendedLabel = computed(() => {
  let label = [];
  if (props.entry.data.isRetrospectivelyAmended) {
    label.push("Edited");
  }

  return label.join(" • ");
});
</script>
